function OrganizationService(ApiService) {
    'ngInject';

    const service = {};

    service.listOrganization = function(url, callbackFunc) {
        ApiService.get(url, callbackFunc);
    };

    service.getOrganization = function(orgId, callbackFunc) {
        ApiService.get(`/organizations/${orgId}/me.json`, callbackFunc);
    };

    service.togglePstToXero = function(orgId, callbackFunc) {
        ApiService.post(`/organizations/${orgId}/toggle_post_to_xero.json`, {}, callbackFunc);
    };

    service.assignUserToOrganization = function(orgId, userId, callbackFunc) {
        ApiService.post(`/organizations/${orgId}/assign_to_user.json`, {user_id: userId}, callbackFunc);
    };

    service.getAssignedUsers = function (orgId, callbackFunc) {
      ApiService.get(`/organizations/${orgId}/assigned_users.json`, callbackFunc)  ;
    };

    service.updateStatus = function (orgId, userId, status, callbackFunc) {
      ApiService.post(`/organizations/${orgId}/add_remove_user.json`,{user:{id: userId, status: status}}, callbackFunc);
    };
    return service;
}

export default {
    name: 'OrganizationService',
    fn: OrganizationService
};